import type {
    ComponentType,
    FC
} from "react";
import type ICarouselPreviousProps from "./type";
import {
    NCoreUIKitLocalize
} from "../../../../core/hooks";
import type {
    CarouselPartContentProps
} from "../../type";
import {
    ChevronLeft as ChevronLeftIcon,
    ChevronUp as ChevronUpIcon
} from "lucide-react-native";
import {
    withCarouselContext
} from "../../context";
import CarouselControl from "../../internal/control";

const CarouselPreviousContent: FC<CarouselPartContentProps<ICarouselPreviousProps>> = ({
    "aria-label": ariaLabel,
    borderRadius,
    customTheme,
    context,
    style
}) => {
    const {
        localize
    } = NCoreUIKitLocalize.useContext(context.customLocalize);

    return <CarouselControl
        icon={context.orientation === "vertical" ? ChevronUpIcon : ChevronLeftIcon}
        isOverlaid={context.controlsPlacement === "inside"}
        customTheme={customTheme ?? context.customTheme}
        label={ariaLabel ?? localize("previous-slide")}
        isDisabled={context.isPreviousDisabled}
        onPress={context.goPrevious}
        borderRadius={borderRadius}
        isSignatureEnabled={true}
        size={context.size}
        style={style}
    />;
};

const CarouselPrevious: ComponentType<ICarouselPreviousProps> = withCarouselContext("previous", CarouselPreviousContent);
export default CarouselPrevious;
